import {
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  styled,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Question } from "@app/models/question.model";

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  border: "1px solid #e0e0e0",
  borderRadius: `${theme.shape.borderRadius}px !important`,
  marginBottom: "8px",
  "&:before": {
    display: "none",
  },
  "&:last-child": {
    marginBottom: 0,
  },
  "& .MuiAccordionSummary-root": {
    backgroundColor: "#f5f5f5",
  },
  "& .MuiAccordionSummary-content": {
    margin: "12px 0",
  },
  "& .MuiAccordionDetails-root": {
    padding: "16px",
  },
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  "& .MuiTypography-root": {
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
  },
  "& .MuiFormControlLabel-root": {
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

interface QuestionCollapseExpandRadioProps {
  questionNumber: number;
  question: Question;
  options: string[];
  value: string;
  onChange: (questionIndex: number, value: string) => void;
  onFocus: (questionNumber: number) => void;
}

function QuestionCollapseExpandRadio({
  questionNumber,
  question,
  options,
  value,
  onChange,
  onFocus
}: QuestionCollapseExpandRadioProps) {
  return (
    <Box sx={{ width: "100%" }} tabIndex={0} onFocus={() => onFocus(questionNumber)}>
      <StyledAccordion key={questionNumber} defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`question-${questionNumber}-content`}
          id={`question-${questionNumber}-header`}
        >
          <Typography>{question.text}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <StyledFormControl>
            <RadioGroup
              value={value || ""}
              onChange={(e) => onChange(questionNumber, e.target.value)}
              name={`question-${questionNumber}`}
            >
              {options.map((option, optionIndex) => (
                <FormControlLabel
                  key={optionIndex}
                  value={option}
                  control={<Radio size="small" />}
                  label={option}
                />
              ))}
            </RadioGroup>
          </StyledFormControl>
        </AccordionDetails>
      </StyledAccordion>
    </Box>
  );
}

export default QuestionCollapseExpandRadio;
